import PartnerPageShell from "./PartnerPageShell";

export default PartnerPageShell;
